import { BaseModel } from './_Index';

export class Lavorazione extends BaseModel{
    organizzazioneId?: number;
}
